import React from "react";
import { Card, Skeleton } from "antd";
import {
  CalendarOutlined,
  FilterOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";

const Space: React.FC<{ children: React.ReactNode; style?: React.CSSProperties; className?: string }> = ({
  children,
  style,
  className,
}) => (
  <div style={style} className={className}>
    {children}
  </div>
);

export const DynamicReportsSkeleton: React.FC = () => {
  return (
    <div>
      {/* Skeleton for Timeframe Settings */}
      <Card
        title={
          <Space style={{ display: "flex", gap: "8px" }} className="flex items-center">
            <CalendarOutlined />
            <span>Timeframe Settings</span>
          </Space>
        }
        className="shadow-md border border-slate-100 rounded-xl mb-6"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-semibold text-slate-300 mb-2">Start Date</label>
            <div className="h-10 bg-slate-50 border border-slate-100 rounded animate-pulse w-full" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-300 mb-2">End Date</label>
            <div className="h-10 bg-slate-50 border border-slate-100 rounded animate-pulse w-full" />
          </div>
        </div>
      </Card>

      {/* Skeleton for Data Scope Filters */}
      <Card
        title={
          <Space style={{ display: "flex", gap: "8px" }} className="flex items-center">
            <FilterOutlined />
            <span>Data Scope Filters</span>
          </Space>
        }
        className="shadow-md border border-slate-100 rounded-xl mb-6"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-semibold text-slate-300 mb-2">Departments</label>
            <div className="h-10 bg-slate-50 border border-slate-100 rounded animate-pulse w-full" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-300 mb-2">Target Employees</label>
            <div className="h-10 bg-slate-50 border border-slate-100 rounded animate-pulse w-full" />
          </div>
        </div>
      </Card>

      {/* Skeleton for Column Selection */}
      <Card
        title={
          <Space style={{ display: "flex", gap: "8px" }} className="flex items-center">
            <FolderOpenOutlined />
            <span>Selected Columns to Include</span>
          </Space>
        }
        className="shadow-md border border-slate-100 rounded-xl mb-6"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="flex items-center gap-2 py-1">
              <div className="w-4 h-4 bg-slate-100 rounded animate-pulse" />
              <div className="h-4 bg-slate-100 rounded animate-pulse w-24" />
            </div>
          ))}
        </div>
      </Card>

      {/* Trigger Button Skeleton */}
      <div className="flex justify-end mt-4">
        <div className="h-10 bg-slate-100 rounded animate-pulse w-48" />
      </div>
    </div>
  );
};
